import { useState } from "react";
import { ColorRing } from "react-loader-spinner";

export default function Button({
  label,
  icon,
  isLoading,
  onClick,
  rounded,
  style,
  variant = "primary",
  disabled = false,
  className = {},
}) {
  const [loading, setLoading] = useState(false);

  const suspenseClick = async () => {
    if (onClick) {
      setLoading(true);
      await onClick();
      setLoading(false);
    }
  };

  const getButtonClasses = () => {
    const baseClasses = `rounded-${
      rounded || "lg"
    } px-3 py-1.5 flex items-center justify-center text-xs font-medium whitespace-nowrap`;
    const variantClasses =
      variant === "primary"
        ? `text-white ${loading ? "bg-gray-300" : "bg-gray-800"}`
        : variant === "secondary"
        ? `text-gray-800 ${
            loading ? "bg-gray-100" : "bg-white"
          } border border-gray-100`
        : `text-gray-800 bg-yellow-300 border-yellow-300`;
    const styleClasses =
      style === "filled" ? "bg-gray-800" : "shadow-xs border";
    const disabledClasses = disabled ? "opacity-50" : "";

    return `${baseClasses} ${variantClasses} ${styleClasses} ${disabledClasses}`;
  };

  return (
    <button
      onClick={suspenseClick}
      disabled={loading || disabled}
      className={`${className} ${getButtonClasses()}`}
    >
      {icon && <div className="w-3 mr-1.5">{icon}</div>}
      {loading || isLoading ? (
        <div className="mr-1.5">
          <ColorRing
            visible={true}
            height="12"
            width="12"
            ariaLabel="blocks-loading"
            colors={
              variant === "primary"
                ? ["#FFF", "#FFF", "#FFF", "#FFF", "#FFF"]
                : ["#1F2937", "#1F2937", "#1F2937", "#1F2937", "#1F2937"]
            }
          />
        </div>
      ) : null}
      <span>{label}</span>
    </button>
  );
}
